const sharedConfig = {
  test: 1,
}

const devConfig = {
  ...sharedConfig,
  apiEndpoint: "https://app-server-dev.newsoveraudio.com",
  websiteUrl: "https://webapp-dev.newsoveraudio.com",
  articlePlayerServer: "https://api.newsoveraudio.com",
}

const stagingConfig = {
  ...sharedConfig,
  apiEndpoint: "https://app-server-staging.newsoveraudio.com",
  websiteUrl: "https://webapp-staging.newsoveraudio.com",
  articlePlayerServer: "https://api.newsoveraudio.com",
}

const prodConfig = {
  ...sharedConfig,
  apiEndpoint: "https://app-server-prod.newsoveraudio.com",
  websiteUrl: "https://newsoveraudio.com",
  articlePlayerServer: "https://api.newsoveraudio.com",
}

let config = devConfig
const env = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV

if (env === "staging") {
  config = stagingConfig
} else if (env === "production") {
  config = prodConfig
}

export default config
